/**
 * Default styles for the link element
 * @type {Object}
 */
export const defaultStyles = {
  // Desktop styles
  desktop: {
    backgroundColor: '#0078d4',
    borderColor: '#0078d4',
    hoverBackgroundColor: '#005fa3',
    hoverBorderColor: '#005fa3',
    activeBackgroundColor: '#00497a',
    activeBorderColor: '#00497a',
    textColor: '#fff',
    fontSize: '15px',
    borderRadius: '4px',
    padding: '8px 8px',
    borderWidth: '1px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.06)'
  },
  // Mobile styles
  mobile: {
    backgroundColor: '#0078d4',
    borderColor: '#0078d4',
    hoverBackgroundColor: '#005fa3',
    hoverBorderColor: '#005fa3',
    activeBackgroundColor: '#00497a',
    activeBorderColor: '#00497a',
    textColor: '#fff',
    fontSize: '16px', // Larger font for mobile
    borderRadius: '8px', // Larger border radius for mobile
    padding: '12px 16px', // Larger padding for mobile
    borderWidth: '1px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.06)'
  }
};

/**
 * Generates the CSS styles for the link element
 * @param {Object} styles - The styles to apply
 * @param {boolean} isMobile - Whether to use mobile styles
 * @returns {string} The CSS styles
 */
export const generateStyles = (styles, isMobile) => {
  const currentStyles = isMobile ? styles.mobile : styles.desktop;
  
  return `
    :host {
      display: inline-block;
      width: ${isMobile ? '100%' : 'auto'};
    }
    .container {
      padding: 0;
      background: none;
      border: none;
      width: 100%;
    }
    .subscribe-link {
      display: block;
      width: 100%;
      box-sizing: border-box;
      text-align: center;
      font-size: ${currentStyles.fontSize};
      font-family: 'Open Sans', Helvetica, Arial, sans-serif;
      color: ${currentStyles.textColor};
      background-color: ${currentStyles.backgroundColor};
      border: ${currentStyles.borderWidth} solid ${currentStyles.borderColor};
      border-radius: ${currentStyles.borderRadius};
      padding: ${currentStyles.padding};
      text-decoration: none;
      cursor: pointer;
      box-shadow: ${currentStyles.boxShadow};
      transition: background 0.2s, color 0.2s, box-shadow 0.2s, border 0.2s;
      outline: none;
      -webkit-tap-highlight-color: transparent; /* Remove tap highlight on mobile */
    }
    .subscribe-link:hover, .subscribe-link:focus {
      background-color: ${currentStyles.hoverBackgroundColor};
      border-color: ${currentStyles.hoverBorderColor};
      color: ${currentStyles.textColor};
      box-shadow: 0 4px 8px rgba(0,0,0,0.10);
      text-decoration: none;
    }
    .subscribe-link:active {
      background-color: ${currentStyles.activeBackgroundColor};
      border-color: ${currentStyles.activeBorderColor};
      color: ${currentStyles.textColor};
      box-shadow: 0 1px 2px rgba(0,0,0,0.08);
    }
    .subscribe-link:visited {
      color: ${currentStyles.textColor};
    }

    /* Mobile-specific styles */
    @media (max-width: 768px) {
      :host {
        width: 100%;
      }
      .subscribe-link {
        font-size: ${currentStyles.fontSize};
        padding: ${currentStyles.padding};
        border-radius: ${currentStyles.borderRadius};
      }
    }
  `;
}; 